import * as React from 'react';
import { TreeViewContext } from './TreeViewContext';
export const useTreeViewContext = () => React.useContext(TreeViewContext);